import { FC } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { CbAvatar } from '../CbAvatar';
import { CbButton } from '../Buttons/CbButton';
import { CommentInitialValues } from '../../types/CommentInitialValues';
import { Formik } from 'formik';
import { CbFormikInputField } from '../CbFormikInputField';
export interface CbCommentBoxProps {
  commentInitialValues: CommentInitialValues;
  onComment: (message: CommentInitialValues) => void;
  onClose: () => void;
  postId?: number;
  userImage: string;
  userName: string;
}
export const CbCommentBox: FC<CbCommentBoxProps> = ({
  commentInitialValues,
  onComment,
  onClose,
  postId,
  userImage,
  userName
}) => {
  return <Formik initialValues={{
    ...commentInitialValues
  }} onSubmit={onComment} validateOnBlur validateOnChange data-sentry-element="Formik" data-sentry-component="CbCommentBox" data-sentry-source-file="CbCommentBox.tsx">
      {({
      handleChange,
      dirty,
      values,
      handleReset
    }) => {
      return <Flex>
            <CbAvatar size={'md'} marginRight={{
          base: 2,
          md: 4
        }} image={userImage} name={userName} />
            <Box width="100%">
              <Flex marginBottom={2}>
                <Text color={'text.secondary'} fontSize={{
              base: 'xs',
              lg: 'md'
            }} fontWeight={'bold'}>
                  {userName}
                </Text>
              </Flex>
              <Flex>
                <CbFormikInputField fieldId="content" placeholder="Write your comment" onChange={handleChange} />
                <CbButton marginLeft={4} onClick={() => {
              onComment({
                ...values,
                activity_id: postId
              }), handleReset();
              onClose();
            }} paddingX={8} aria-label="Post to feed" isDisabled={!dirty}>
                  {'Post'}
                </CbButton>
              </Flex>
            </Box>
          </Flex>;
    }}
    </Formik>;
};